import moment, {Moment} from 'moment-timezone';

import parse from 'url-parse';
import {TFunction} from "@nic-react-i18n/core";
import {Location} from 'react-router'
import dayjs from "dayjs";

const BOOKING_BASE = '/bookings/calendar';

const monthRequest = (request: any) => {
    return request.month;
};

const dayRequest = (request: any) => {
    return request.month + '/' + request.day;
};

const weekRequest = (request: any) => {
    let day = (request.day ? request.day : '01');
    let month = (request.month ? request.month : '01');
    let date = request.year + '-' + month + '-' + day;
    let week = moment(date).isoWeek();
    return week;
};

const yearRequest = (request: any) => {
    return null;
};

const requestFun: Record<string, any> = {
    month: monthRequest,
    day: dayRequest,
    week: weekRequest,
    year: yearRequest
};

export const requestBuilder = (request: any, base = BOOKING_BASE) => {
    let res = base + '/';
    res += request.period + '/';
    res += request.year + '/';

    res += requestFun[request.period](request);
    return res;
};

const yearFromDate = (date: Moment) => {
    return date.year() + '/';
};

const monthFromDate = (date: Moment) => {
    return date.year() + '/' + (date.month() + 1);
};

const dayFromDate = (date: Moment) => {
    return date.year() + '/' + (date.month() + 1) + '/' + date.date();
};

const weekFromDate = (date: Moment) => {
    return date.year() + '/' + date.isoWeek();
};

export const requestFromDate: Record<string, any> = {
    year: yearFromDate,
    month: monthFromDate,
    week: weekFromDate,
    day: dayFromDate
};

export const builBaseRequest = (request: any,  base = BOOKING_BASE) => {
    let res = base + '/';
    res += request.period + '/';
    return res;
};

export const buildRequestFromDate = (request: any, date: dayjs.Dayjs, base = BOOKING_BASE) => {

    let res = base + '/';

    res += request.period + '/';

    res += requestFromDate[request.period](date);
    return res;
};

export const dateBuilder = (params: any) => {
    let res ;
    switch (params.period) {
        case 'week': {
            res = dayjs().year(params.year).isoWeek(params.month);
            // res = params.year + '-' + (String(date.month())) + '-' + (String(date.date()));
            break;
        }
        default: {
            let month: number = params.month || 1;
            let day: number = params.day || 1;
            let year: number = params.year || moment().year();
            res = dayjs().year(year).month(month - 1).date(day);
            break;
        }
    }
    //console.log("dateBuilder: ", res)
    return res;
};

export const nextPeriod = (params: any) => {
    return dayjs(dateBuilder(params)).add(1, params.period??'month');
};

export const prevPeriod = (params: any) => {
    return dayjs(dateBuilder(params)).subtract(1, params.period??'month');
};

export const nextCallBuilder = (params: any, date: dayjs.Dayjs) => {
    let res = {kind: '', period: '', year: '', month: '', day: ''};

    switch (params.period) {
        case 'year':  {
            res.kind = params.kind;
            res.period = 'month';
            res.year = params.year;
            res.month = date.format('MM');
            break;
        }
        case 'month':
            res.kind = params.kind;
            res.period = 'day';
            res.year = params.year;
            res.month = params.month;
            res.day = date.format('DD');
            break;
        case 'day':
            break;
        default:
            break;
    }

    return res;
};

interface QueryInterface {
    from?: string;
    to?: string;
}

export const formatDateFromParams = (params: any, query: QueryInterface): dayjs.Dayjs => {
    // let month: string = '01';
    // let day: string = '01';
    let res;

    const containsQuery = (Object.keys(query).length > 0);

    if (containsQuery) {
        res = (query.from ? dayjs(query.from) : dayjs());
    } else {
        switch (params.period) {
            case 'week': {
                res = dayjs().year(params.year).isoWeek(params.month);

                break;
            }
            case 'year': {
                res = dayjs().year(params.year);

                break;
            }
            case 'month': {
                let month: number = params.month as number;
                res = dayjs().year(params.year).month((month - 1));

                break;
            }

            case 'range': {
                res = dayjs();

                break;
            }
            case 'day': {
                let month: number = params.month as number;
                res = dayjs().year(params.year).month((month - 1)).date(params.day);

                break;
            }

            default: {

                res = dayjs();
                break;
            }

        }
    }

    return res;

};

const formatter: Record<string, string> = {
    day: 'DD MMMM YYYY',
    month: 'MMMM YYYY',
    week: 'WW YYYY',
    year: 'YYYY'
};

export const titleFromParams = (params: any, location: Location<any>, t: TFunction) => {

    const fullPath = location.pathname + location.search;
    const url = parse(fullPath, true);

    let title;

    switch (params.period) {
        case 'week': {
            title = t('title.week') + ' ' +
                params.month + t('title.of') + params.year;

            break;
        }
        case 'range': {

            title = t('title.range', {from: url.query.from, to: url.query.to});
            break;
        }

        default: {
            const date = formatDateFromParams(params,  url.query);
            title = dayjs(date).format(formatter[params.period]);
            break;
        }
    }
    return title;
};